module.exports = __webpack_public_path__ + "img/13.255bb36c.png";